export function TranslationsNederlands() 
{
    return [  
        {"id":"Add call note","value":"Gespreksnotitie toevoegen"},
        {"id":"Add to speed dial","value":"Aan snelkeuze toevoegen"},
        {"id":"All","value":"Alles"},
        {"id":"An error has occurred while searching","value":"Er is een fout opgetreden tijdens het zoeken"},  
        {"id":"Analog phone","value":"Analoge telefoon"}, 
        {"id":"Always","value":"Altijd"},   
        {"id":"Always create new ticket","value":"Creëer altijd nieuw ticket"},       
        {"id":"API token","value":"API token"},            
        {"id":"Asterisk serial","value":"Asterisk serial"},    
        {"id":"Auto Answer","value":"Automatisch beantwoorden"},    
        {"id":"Automatic actions","value":"Automatische acties"},     
        {"id":"Available callfields","value":"Beschikbare gespreksvelden"},  
        {"id":"Body","value":"Inhoud"}, 
        {"id":"Browser notifications","value":"Browser notificaties"},  
        {"id":"Browser notifications activated","value":"Browser notificaties zijn geactiveerd"},   
        {"id":"Browser notifications are currently disabled","value":"Browser notificaties zijn momenteel uitgeschakeld"}, 
        {"id":"Browser notifications are currently enabled","value":"Browser notificaties zijn momenteel ingeschakeld"},  
        {"id":"Call","value":"Bellen"},       
        {"id":"Call back","value":"Terugbellen"},
        {"id":"Called","value":"Gebeld"},       
        {"id":"Caller","value":"Beller"},       
        {"id":"Caller recognition and scripts","value":"Beller herkenning en scripts"},     
        {"id":"Change recognition order","value":"Verander volgorde van herkenning"},   
        {"id":"Clear call","value":"Gesprek opschonen"},   
        {"id":"Click here to open the webconfigurator to configure your CRM","value":"Klik hier om de webconfigurator te openen om uw CRM te configureren"},
        {"id":"Click-to-call","value":"Click-to-call"},
        {"id":"comma-separated","value":"komma-gescheiden"},
        {"id":"Configure your CRM","value":"Configureer uw CRM"},  
        {"id":"Configure user settings","value":"Configureer gebruikersinstellingen"},        
        {"id":"Copy number","value":"Kopieer nummer"},      
        {"id":"Copy phone number","value":"Kopieer telefoonnummer"},
        {"id":"Country Code","value":"Landcode"}, 
        {"id":"Create and show contact","value":"Creëer en toon gebruiker"}, 
        {"id":"Create and show new Zoho contact when no matches are found","value":"Creëer en toon new Zoho contact als geen matches gevonden worden"}, 
        {"id":"Create and show user","value":"Creëer en toon gebruiker"}, 
        {"id":"Create calls in Zoho","value":"Creëer gesprekken in Zoho"},         
        {"id":"Create company and link to call","value":"Creëer bedrijf en koppel aan gesprek"},   
        {"id":"Create contact and link to call","value":"Creëer contact en koppel aan gesprek"},   
        {"id":"Create user and create and show ticket","value":"Creëer gebruiker en creëer en toon ticket"}, 
        {"id":"CRMs and scripts","value":"CRMs en scripts"},           
        {"id":"Default inbound call subject","value":"Standaard onderwerp voor inkomende gesprekken"}, 
        {"id":"Default outbound call subject","value":"Standaard onderwerp voor uitgaande gesprekken"}, 
        {"id":"Default ticket for inbound calls","value":"Standaard ticket voor inkomende gesprekken"}, 
        {"id":"Default ticket for outbound calls","value":"Standaard ticket voor uitgaande gesprekken"},       
        {"id":"Desktop phone","value":"Desktop telefoon"},  
        {"id":"Device","value":"Toestel"},
        {"id":"Dialer URL Protocol","value":"Uitbel URL Protocol"},
        {"id":"Disable","value":"Uitschakelen"},
        {"id":"Enable","value":"Inschakelen"},
        {"id":"Error","value":"Fout"}, 
        {"id":"Extension","value":"Extensie"},       
        {"id":"External phone/PBX","value":"Externe telefoon/PBX"},        
        {"id":"Failed to subscribe for phone events","value":"Kan niet abonneren op telefonie events"},
        {"id":"History","value":"Geschiedenis"},
        {"id":"Host URL","value":"Host URL"},
        {"id":"Inbound call","value":"Inkomend gesprek"},
        {"id":"Incoming","value":"Inkomend"},
        {"id":"Incoming call","value":"Inkomend gesprek"},  
        {"id":"Incoming call from","value":"Inkomend gesprek naar"},  
        {"id":"Language","value":"Taal"},
        {"id":"License","value":"Licentie"},
        {"id":"Mobile phone","value":"Mobiele telefoon"},  
        {"id":"More results found. Refine your search","value":"Meer resultaten gevonden. Verfijn uw zoekopdracht"}, 
        {"id":"Multiple open tickets → show user","value":"Meerdere open tickets → toon gebruiker"},   
        {"id":"Name","value":"Naam"}, 
        {"id":"Never","value":"Nooit"},   
        {"id":"No","value":"Nee"}, 
        {"id":"No action","value":"Geen actie"}, 
        {"id":"No matching Zendesk record","value":"Geen overeenkomend Zendesk record"},   
        {"id":"No open tickets → create and show new ticket","value":"Geen open ticket → creëer en toon nieuw ticket"}, 
        {"id":"No recent call information available","value":"Geen recente gespreksinformatie beschikbaar"},   
        {"id":"No results found","value":"Geen resultaten gevonden"},   
        {"id":"No incoming call information available","value":"Geen inkomende gespreksinformatie beschikbaar"},   
        {"id":"Note","value":"Notitie"},
        {"id":"Notes","value":"Notities"},
        {"id":"Number","value":"Nummer"},
        {"id":"off","value":"uit"},
        {"id":"on","value":"aan"},
        {"id":"One open ticket → show open ticket","value":"Één open ticket → toon open ticket"},
        {"id":"Only when there is a single-matching Zendesk record","value":"Alleen als er een enkele match is in Zendesk"},
        {"id":"Open company","value":"Bedrijf openen"},
        {"id":"Open contact","value":"Contact openen"},
        {"id":"Open note in HubSpot","value":"Notitie in HubSpot openen"},
        {"id":"Open single-matching Zoho record","value":"Open enkele match in Zoho"},        
        {"id":"Outbound","value":"Uitgaand"}, 
        {"id":"Outbound call","value":"Uitgaand gesprek"}, 
        {"id":"Outbound call body","value":"Uitgaand gesprek body"}, 
        {"id":"Outgoing","value":"Uitgaand"}, 
        {"id":"Outgoing call to","value":"Uitgaand gesprek naar"}, 
        {"id":"Password","value":"Wachtwoord"},  
        {"id":"Phone type","value":"Telefoon type"},
        {"id":"Privacy statement","value":"Privacyverklaring"},        
        {"id":"Remove from speed dial","value":"Verwijderen uit snelkeuze"},
        {"id":"Remove from view","value":"Verwijderen uit weegave"},  
        {"id":"Sandbox account","value":"Zoeken"}, 
        {"id":"Save call","value":"Gesprek opslaan"}, 
        {"id":"Search","value":"Zoeken"}, 
        {"id":"Search field must contain at least 3 characters","value":"Zoekveld moet ten minste 3 karakters bevatten"}, 
        {"id":"Searching","value":"Bezig met zoeken"},
        {"id":"Search field must contain at least 3 characters","value":"Zoekveld moet ten minste 3 karakters bevatten"}, 
        {"id":"Settings","value":"Instellingen"}, 
        {"id":"Show open ticket if there is only one","value":"Toon open ticket als er maar een is"},
        {"id":"Show user","value":"Toon gebruiker"},
        {"id":"Sign out","value":"Afmelden"},
        {"id":"Signed in as","value":"Aangemeld als"},
        {"id":"Single-matching Zendesk record","value":"Precies één overeenkomend Zendesk record"},  
        {"id":"Sip Account","value":"Sip Account"},
        {"id":"Smart handling","value":"Slimme modus"},
        {"id":"Softphone","value":"Softphone"},  
        {"id":"Speed dial","value":"Snelkeuze"}, 
        {"id":"Settings","value":"Instellingen"}, 
        {"id":"Telephony","value":"Telefonie"},
        {"id":"Telephony platform","value":"Telefonie platform"},  
        {"id":"Terms and conditions","value":"Algemene voorwaarden"},   
        {"id":"Theme","value":"Thema"},
        {"id":"Time","value":"Tijd"},    
        {"id":"Trunk Access Code","value":"Toegangscode Buitenlijn"}, 
        {"id":"Type a name or number","value":"Typ een naam of nummer"}, 
        {"id":"Unknown contact","value":"Onbekend contact"},    
        {"id":"Update","value":"Updaten"},  
        {"id":"Update settings","value":"Update instellingen"},  
        {"id":"URL","value":"URL"},    
        {"id":"User ID","value":"Gebruiker ID"},    
        {"id":"User PIN","value":"Gebruiker PIN"},    
        {"id":"User settings","value":"Gebruikersinstellingen"},
        {"id":"Username","value":"Gebruikersnaam"},
        {"id":"Version","value":"Versie"},
        {"id":"View note","value":"Notitie openen"},
        {"id":"What actions should be automatically performed?","value":"Welke acties moeten automatisch worden uitgevoerd?"},
        {"id":"When you answer the call","value":"Wanneer u het gesprek ontvangt"},
        {"id":"When you end the call","value":"Wanneer u het gesprek beantwoordt"},
        {"id":"When you receive the call","value":"Wanneer u het gesprek beeindigt"},
        {"id":"Yes","value":"Ja"},    
        {"id":"Your phone is connected","value":"Uw telefoon is verbonden"}, 
        {"id":"Your organization","value":"Uw organisatie"},
        // HubSpot embedded
        {"id":"Call back","value":"Terugbellen"}, 
        {"id":"Company found and selected","value":"Bedrijf gevonden en geselecteerd"}, 
        {"id":"Company name","value":"Bedrijfsnaam"},
        {"id":"Copy phonenumber","value":"Telefoonnummer kopiëren"}, 
        {"id":"Create company","value":"Bedrijf aanmaken"}, 
        {"id":"Create company and link to call","value":"Bedrijf aanmaken en aan gesprek koppelen"}, 
        {"id":"Create contact","value":"Contact aanmaken"}, 
        {"id":"Create contact and link to call","value":"Contact aanmaken en aan gesprek koppelen"}, 
        {"id":"Add task for chosen contact/company","value":"Taak aanmaken voor gekozen contact/bedrijf"}, 
        {"id":"Domain","value":"Domein"},
        {"id":"Email","value":"E-mail"},
        {"id":"First name","value":"Voornaam"},
        {"id":"Last name","value":"Achternaam"},
        {"id":"Name","value":"Naam"},
        {"id":"Notes","value":"Notities"}, 
        {"id":"Save call","value":"Gesprek opslaan"},  
        {"id":"Search company name","value":"Bedrijfsnaam zoeken"},  
        {"id":"Something went wrong, please contact support","value":"Er is iets misgegaan, neem contact op met support"},  
        {"id":"Unknown caller","value":"Onbekende beller"}, 
        {"id":"View note","value":"Notitie bekijken"},
        {"id":"Company name","value":"Bedrijfsnaam"},
        {"id":"Create contact","value":"Contact aanmaken"},
        {"id":"Create company","value":"Bedrijf aanmaken"},
        {"id":"Domain","value":"Domein"},
        {"id":"Email","value":"E-mail"},
        {"id":"First name","value":"Voornaam"},
        {"id":"Last name","value":"Achternaam"},
        {"id":"Name","value":"Naam"},
        {"id":"Phone number","value":"Telefoonnummer"}
    ]
}